import {FC} from 'react'
import {AppLoading} from './AppLoading'

type props = {text?: string}

const ListLoading: FC<props> = ({text}) => (
  <AppLoading
    mode='overlay'
    message={text || 'در حال پردازش اطلاعات…'}
    detail='تا پایان عملیات این صفحه را نبندید'
  />
)

export {ListLoading}
